import { FullScreenLoadingContainer } from "./styles";
import loadingImg from 'src/assets/loader-green.svg'

const FullScreenLoading = ({active}: any) => {
  return active && (
    <FullScreenLoadingContainer>
      <img src={loadingImg} alt="loading" style={{margin: "49vh 49vw"}} />
    </FullScreenLoadingContainer>
  );
}

export default FullScreenLoading;